import api from '../token';

export const ListNoticia = async (payload) => {
  try {
    const response = await api.post('/getNoticia',payload);
    return response.data;
  } catch (error) {
   
    return [];
  }
};

